module.exports = __webpack_public_path__ + "static/media/Logo-Horizontal.7687246a.svg";